namespace Areas.Submittal.Edit {
    "use strict";

    var tabItems = Areas.createTabsWithSameAction("Submittal", "Edit",
        ["Profile", "Tracking"]);

    export function tabInitialized(params: any) {
        return Areas.tabWithIdInitialized(tabItems)(params);
    }


    export function returnToListFromTab() {
        var linkInfo = "/Submittal/List/Active";
        location.href = linkInfo;

    }
}
